export type ExportArtifact = Readonly<{ bytes: Uint8Array; mediaType: string }>;

/** Upload only the finished artifact, with no source image, filename or instructions. */
export async function storeExportImage(artifact: ExportArtifact): Promise<Record<string, string>> {
  try {
    const response = await fetch("/api/v1/stencil-exports", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": artifact.mediaType },
      body: new Blob([new Uint8Array(artifact.bytes)], { type: artifact.mediaType }),
      signal: AbortSignal.timeout(30_000),
    });
    if (!response.ok) return { image_url_status: "unavailable", image_url_error: `http_${response.status}` };
    const data = await response.json() as { asset?: { id?: unknown; expiresAt?: unknown } };
    if (typeof data.asset?.id !== "string" || !/^ast_[a-zA-Z0-9_-]{8,128}$/.test(data.asset.id)
      || typeof data.asset.expiresAt !== "string" || !Number.isFinite(Date.parse(data.asset.expiresAt))) {
      return { image_url_status: "unavailable", image_url_error: "invalid_response" };
    }
    return {
      image_url: new URL(`/api/v1/admin/photos/assets/${data.asset.id}`, window.location.origin).href,
      image_url_status: "available",
      image_url_expires_at: new Date(data.asset.expiresAt).toISOString(),
    };
  } catch {
    return { image_url_status: "unavailable", image_url_error: "upload_failed" };
  }
}
